






import Vue from 'vue'
export default Vue.extend({
  computed: {
    path(): string | (string | null)[] {
      return this.$route.query.path
    }
  }
})
